export const removeDashboardFixedCacheKey =
  "deleteUsersMeOrganisationsCurrentDashboardsByDashboardId-fixed-cache-key";
export const createDashboardFixedCacheKey =
  "postUsersMeOrganisationsCurrentDashboards-fixed-cache-key";
export const updateDashboardFixedCacheKey =
  "patchUsersMeOrganisationsCurrentDashboardsByDashboardId-fixed-cache-key";
export const createWidgetFixedCacheKey =
  "postUsersMeOrganisationsCurrentDashboardsByDashboardIdWidgets-fixed-cache-key";
